import { render, staticRenderFns } from "./BalanceOverviewCard.vue?vue&type=template&id=6287be8a&scoped=true&"
import script from "./BalanceOverviewCard.vue?vue&type=script&lang=js&"
export * from "./BalanceOverviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287be8a",
  null
  
)

export default component.exports